export const ACCESS_TOKEN_KEY = 'voucher-access-token';
export const COOKIES_POLICY_KEY = 'voucher-cookies-policy-acceptance';
